import { GameStatus } from "sbtech-sports-data-api-contracts";
export var mapKickOffState = function (x) {
    x.isInKickOffState = x.isLive && x.status === GameStatus.NotStarted;
    return x;
};
//# sourceMappingURL=mapKickOffState.js.map